<template>
    <!-- 模拟登录过度页 -->
    <div class="excessive_page"  
        v-loading.fullscreen.lock="loading"
        element-loading-text="模拟登录中..."
    >

    </div>
</template>

<script setup>
import { usePlayStore } from '@/store/modules/play';
const playStore = usePlayStore()
const { setIsMoniLogin } = playStore
const loading = ref(true)
const router = useRouter()
onMounted(()=>{
    setIsMoniLogin(true)
    router.replace({
        path:"/studyCenter/courseUser"
    })
})
</script>

<style lang="scss" scoped>
.excessive_page{
    width: 100%;
    height: 100%;
    background-image: url('@/assets/images/exp-login.png');
    background-size: 100% 100%;
}
</style>